import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isPostCommentRequestFailure({ uuid }) {
      const req = getState().find(({ discussion }) => discussion.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isPostCommentRequestPending({ uuid }) {
      const req = getState().find(({ discussion }) => discussion.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isPostCommentRequestSuccess({ uuid }) {
      const req = getState().find(({ discussion }) => discussion.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
